import React from 'react';

const contactCards = [
  {
    label: 'Call Us',
    value: '+91 8943 493493',
    description: 'Speak with our team for hiring support, candidate guidance, and service enquiries.'
  },
  {
    label: 'Email Us',
    value: 'danijobclub@gmail.com',
    description: 'Send your requirement, service request, or business enquiry and we will respond promptly.'
  },
  {
    label: 'Visit Us',
    value: 'Dani Job Club, Kerala, India',
    description: 'Meet us for recruitment planning, candidate support, or partnership discussions.'
  }
];

const quickPoints = [
  'Fast response for employer and candidate enquiries',
  'Support for recruitment, staffing, services, and registration',
  'Clear communication during working hours'
];

const Contact = () => {
  return (
    <div className="min-h-screen bg-white text-black py-8 md:py-10">
      <div className="w-[calc(100%-1.5rem)] md:w-[calc(100%-3rem)] xl:w-[calc(100%-12rem)] mx-auto space-y-8">
        <section className="relative overflow-hidden rounded-[36px] border border-yellow-300 bg-gradient-to-br from-black via-neutral-900 to-yellow-500 px-6 py-10 md:px-10 md:py-14 text-white">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(255,214,10,0.28),transparent_28%),radial-gradient(circle_at_bottom_left,rgba(255,255,255,0.12),transparent_24%)]" />
          <div className="relative grid grid-cols-1 xl:grid-cols-[1.2fr_0.9fr] gap-8 items-center">
            <div>
              <p className="text-sm font-extrabold uppercase tracking-[0.32em] text-yellow-300">Contact Us</p>
              <h1 className="mt-4 text-4xl md:text-5xl xl:text-6xl font-extrabold leading-tight">
                A cleaner way to reach Dani Job Club.
              </h1>
              <p className="mt-5 max-w-3xl text-base md:text-lg leading-8 text-white/85">
                Whether you are hiring, applying, or exploring our services, this contact page is structured to make communication feel direct, clear, and professional.
              </p>

              <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
                {quickPoints.map((point) => (
                  <div key={point} className="rounded-[24px] border border-white/15 bg-white/10 px-4 py-4 backdrop-blur-sm text-sm font-semibold leading-6 text-white/90">
                    {point}
                  </div>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-1 gap-4">
              {contactCards.map((card, index) => (
                <div key={card.label} className="rounded-[28px] border border-white/15 bg-white/10 px-5 py-5 backdrop-blur-sm">
                  <p className="text-xs font-extrabold uppercase tracking-[0.24em] text-yellow-300">0{index + 1} {card.label}</p>
                  <p className="mt-3 text-2xl font-extrabold">{card.value}</p>
                  <p className="mt-2 text-sm leading-6 text-white/80">{card.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="grid grid-cols-1 xl:grid-cols-[0.92fr_1.08fr] gap-6">
          <div className="rounded-[32px] border border-gray-200 bg-white shadow-[0_22px_65px_rgba(0,0,0,0.06)] overflow-hidden">
            <div className="border-b border-gray-200 px-6 py-6 md:px-8">
              <p className="text-sm font-extrabold uppercase tracking-[0.28em] text-yellow-500">Send Message</p>
              <h2 className="mt-2 text-3xl font-extrabold text-black">Tell us what you need</h2>
              <p className="mt-3 text-gray-600 leading-7">
                Share your requirement and our team will get back to you with the right next step.
              </p>
            </div>

            <form className="px-6 py-6 md:px-8 md:py-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <label className="block">
                  <span className="text-sm font-bold text-black">Your Name</span>
                  <input
                    type="text"
                    placeholder="Enter your full name"
                    className="mt-2 w-full rounded-2xl border border-gray-300 bg-gray-50 px-4 py-3 text-black outline-none focus:border-yellow-400 focus:bg-white focus:ring-2 focus:ring-yellow-200"
                    required
                  />
                </label>

                <label className="block">
                  <span className="text-sm font-bold text-black">Your Email</span>
                  <input
                    type="email"
                    placeholder="Enter your email"
                    className="mt-2 w-full rounded-2xl border border-gray-300 bg-gray-50 px-4 py-3 text-black outline-none focus:border-yellow-400 focus:bg-white focus:ring-2 focus:ring-yellow-200"
                    required
                  />
                </label>

                <label className="block md:col-span-2">
                  <span className="text-sm font-bold text-black">Subject</span>
                  <input
                    type="text"
                    placeholder="Recruitment, staffing, service enquiry, or support"
                    className="mt-2 w-full rounded-2xl border border-gray-300 bg-gray-50 px-4 py-3 text-black outline-none focus:border-yellow-400 focus:bg-white focus:ring-2 focus:ring-yellow-200"
                    required
                  />
                </label>

                <label className="block md:col-span-2">
                  <span className="text-sm font-bold text-black">Message</span>
                  <textarea
                    placeholder="Write your message here"
                    className="mt-2 w-full rounded-2xl border border-gray-300 bg-gray-50 px-4 py-3 text-black outline-none focus:border-yellow-400 focus:bg-white focus:ring-2 focus:ring-yellow-200"
                    rows="6"
                    required
                  />
                </label>
              </div>

              <div className="mt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <p className="text-sm text-gray-600">Business Hours: Mon-Fri 9:00am - 6:00pm</p>
                <button
                  type="submit"
                  className="inline-flex items-center justify-center rounded-xl bg-yellow-400 px-6 py-3 text-black font-extrabold hover:bg-yellow-300 transition"
                >
                  Send Message
                </button>
              </div>
            </form>
          </div>

          <div className="grid grid-cols-1 gap-6">
            <div className="rounded-[32px] border border-yellow-300 bg-yellow-50 px-6 py-7 md:px-8 shadow-[0_20px_60px_rgba(250,204,21,0.14)]">
              <p className="text-sm font-extrabold uppercase tracking-[0.28em] text-yellow-600">Office Details</p>
              <h2 className="mt-3 text-3xl font-extrabold text-black">Reach us through the channel that suits you.</h2>

              <div className="mt-6 space-y-5 text-gray-700">
                <div>
                  <p className="text-xs font-extrabold uppercase tracking-[0.2em] text-gray-500">Address</p>
                  <p className="mt-2 text-lg font-bold text-black">Dani Job Club, Kerala, India</p>
                </div>
                <div>
                  <p className="text-xs font-extrabold uppercase tracking-[0.2em] text-gray-500">Phone</p>
                  <p className="mt-2 text-lg font-bold text-black">+91 8943 493493</p>
                </div>
                <div>
                  <p className="text-xs font-extrabold uppercase tracking-[0.2em] text-gray-500">Email</p>
                  <p className="mt-2 text-lg font-bold text-black">danijobclub@gmail.com</p>
                </div>
                <div>
                  <p className="text-xs font-extrabold uppercase tracking-[0.2em] text-gray-500">Working Hours</p>
                  <p className="mt-2 text-lg font-bold text-black">Monday to Friday, 9:00 AM to 6:00 PM</p>
                </div>
              </div>
            </div>

            <div className="rounded-[32px] border border-gray-200 bg-white overflow-hidden shadow-[0_22px_65px_rgba(0,0,0,0.06)]">
              <div className="px-6 py-5 md:px-8 border-b border-gray-200">
                <p className="text-sm font-extrabold uppercase tracking-[0.28em] text-yellow-500">Location Map</p>
                <h2 className="mt-2 text-2xl font-extrabold text-black">Find us easily</h2>
              </div>
              <div className="p-4 md:p-5">
                <div className="overflow-hidden rounded-[24px] border border-gray-200">
                  <iframe
                    title="Google Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.019123456789!2d-122.419415484681!3d37.7749297797597!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085809c5b5b5b5b%3A0x5b5b5b5b5b5b5b5b!2s123+Main+St%2C+San+Francisco%2C+CA!5e0!3m2!1sen!2sus!4v1610000000000!5m2!1sen!2sus"
                    width="100%"
                    height="320"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Contact;
